'use client';

import { AppDownloadPrompt } from './AppDownloadPrompt';
import { ReportPrompt } from './ReportPrompt';
import { ReviewPrompt } from './ReviewPrompt';
import { usePromptContext } from '@/providers/PromptProvider';

/**
 * Renders whichever contextual prompt is currently active. Mounted
 * once at the app root, inside PromptProvider. Each prompt component
 * reads `open` from the shared context so navigation between pages
 * doesn't affect visibility.
 */
export function PromptOverlay() {
  const { activePrompt } = usePromptContext();

  return (
    <>
      <ReportPrompt open={activePrompt === 'report'} />
      <ReviewPrompt open={activePrompt === 'review'} />
      <AppDownloadPrompt open={activePrompt === 'appDownload'} />
    </>
  );
}
